import axios from '../shared/axios';
// import qs from 'querystring';
import store from "../store/store";
import * as contractDuck from "../store/ducks/contract.duck";
import * as actionsDuck from "../store/ducks/actions.duck";


export function generateSubscriptionURL(payload) {
    return axios.post(`/api/Calendar/GenerateSubscriptionURL`,payload);
}
export function updateSubscriptionURL(payload) {
    return axios.post(`/api/Calendar/UpdateSubscriptionURL`,payload);
}
export function cancelSubscription() {
    return axios.post(`/api/Calendar/CancelSubscription`);
}
export function getICS(Key) {
    return axios.get(`/api/Calendar/v1/Get`,{ params: { Key }, responseType: 'blob' });
}
export function getActiveSubscription() {
    return axios.get(`/api/Calendar/GetActiveSubscription`);
}